import Arrow from "../Arrow";

export default class ArrowContainer {
  private mArrows: Arrow[] = [];

  public Add(arrow: Arrow): void {
    this.mArrows.push(arrow);
  }

  public Remove(arrow: Arrow): void {
    const idx = this.mArrows.indexOf(arrow);
    if (idx > -1) {
      this.mArrows.splice(idx, 1);
    }
  }

  public GetAll(): Arrow[] {
    return this.mArrows;
  }

  public Replace(arrows: Arrow[]): void {
    this.mArrows = arrows;
  }
}
